import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import React from "react";
import strings from "../config/localization";

interface Props {
  title?: string;
  message: string;
}

export default function GeneralFailure({
  title = strings.error,
  message,
}: Props) {
  return (
    <Alert severity="error">
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
  );
}
